import React from "react";
import ReactDOM from "react-dom/client";
import { toast } from "sonner";
import "@/index.css";
import App from "@/App";

// Register service worker for PWA
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw-push.js')
      .then(registration => {
        // iter200 — Detect a new SW version waiting to activate and prompt
        // the user with an "App updated, tap to reload" toast instead of
        // forcing an invisible refresh. Triggers when:
        //   1. The current page already had a controlling SW (i.e. this
        //      is a returning user, not the very first install)
        //   2. AND a new SW finished install and is now in 'waiting' state
        function promptForReload(waitingSw) {
          toast('App updated · tap to reload for latest version', {
            duration: Infinity,
            action: {
              label: 'Reload',
              onClick: () => {
                waitingSw.postMessage({ type: 'SKIP_WAITING' });
              },
            },
          });
        }
        // Case 1: a waiter is already there at page load (e.g. user kept
        // the tab open through a deploy and only just refocused).
        if (registration.waiting && navigator.serviceWorker.controller) {
          promptForReload(registration.waiting);
        }
        // Case 2: detect mid-session installs.
        registration.addEventListener('updatefound', () => {
          const newSw = registration.installing;
          if (!newSw) return;
          newSw.addEventListener('statechange', () => {
            if (newSw.state === 'installed' && navigator.serviceWorker.controller) {
              promptForReload(newSw);
            }
          });
        });
        // Once the user accepts the prompt, the new SW activates and the
        // controllerchange event fires — reload the page to load the new
        // bundles served by the freshly-activated worker.
        let refreshing = false;
        navigator.serviceWorker.addEventListener('controllerchange', () => {
          if (refreshing) return;
          refreshing = true;
          window.location.reload();
        });
        console.log('SW registered:', registration.scope);
      })
      .catch(error => {
        console.log('SW registration failed:', error);
      });
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
